import i18next from "i18next";

import { createColumn } from "../../../../../../components/Table";

export const devicesTableColumns = [
  createColumn({
    keyName: "name",
    header: () => i18next.t("patientPage_columns_device"),
    cell: (info) => info.renderValue(),
    size: 200,
  }),
  createColumn({
    keyName: "added",
    header: () => i18next.t("patientPage_columns_added"),
    cell: (info) => info.renderValue(),
  }),

  createColumn({
    keyName: "identifier",
    header: () => i18next.t("patientPage_columns_identifier"),
    cell: (info) => info.renderValue(),
  }),

  createColumn({
    keyName: "firstUsed",
    header: () => i18next.t("patientPage_columns_first_used"),
    cell: (info) => info.renderValue(),
  }),

  createColumn({
    keyName: "lastUsed",
    header: () => i18next.t("patientPage_columns_last_used"),
    cell: (info) => info.renderValue(),
  }),

  createColumn({
    keyName: "batteryLevel",
    header: () => i18next.t("patientPage_columns_battery_level"),
    cell: (info) => info.renderValue(),
  }),

  createColumn({
    keyName: "action",
    header: () => "",
    cell: (info) => info.renderValue(),
    size: 10,
  }),
];

export const mobileAccordionListColumns = [
  { key: "Hospital ID", value: "hospitalId" },
  { key: "Survey ID", value: "id" },
];
